import crypto from "crypto";

import { validateEmailStrictly } from "seneca-common/utils/functions/validationFunctions";

export function getFirebaseEmail(email: string): string {
  return validateEmailStrictly(email) ? transformEmail(email) : email;
}

export function transformEmail(email: string) {
  return `${crypto
    .createHash("sha256")
    .update(email)
    .digest("hex")}@seneca.com`;
}
